import { createSelector } from 'reselect';
import identity from 'lodash/identity';

import DialogName from '../constants/DialogName';
import getDialogProp from './getDialogProp';

const getQueryBuilderForAddRuleWorksheet = createSelector(
  identity,
  getDialogProp(DialogName.ADD_RULE_WORKSHEET, 'queryBuilder'),
);

export default getQueryBuilderForAddRuleWorksheet;
